import task from '@/components/competitors/task/storage';
import taskList from '@/components/competitors/taskList/storage';
import archiveList from '@/components/competitors/archiveList/storage';
import list from '@/components/competitors/list/storage';
import viewTask from '@/components/competitors/viewTask/storage';

export default {
    namespaced: true,
    modules: {
        task,
        taskList,
        archiveList,
        list,
        viewTask,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}